import modal from './Modal';

export default function wishlistModal() {
  return {
    ...modal(),
  };
}
